import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

export const appGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> => {
  const keycloak = inject(KeycloakService);
  const router = inject(Router);

  const authenticated = keycloak.isLoggedIn();

  if (!authenticated) {
    await keycloak.login({ redirectUri: window.location.href }).catch((e) => console.error(e));
    return false;
  }

  try {
    await keycloak.updateToken(30);
  } catch {
    await keycloak.login({ redirectUri: window.location.href }).catch((e) => console.error(e));
    return false;
  }

  const requiredRoles: string[] = route.data['roles'];

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const userRoles = keycloak.getUserRoles();
  const hasRole = requiredRoles.some((role) => userRoles.includes(role));

  if (!hasRole) {
    return router.parseUrl('/404');
  }

  return true;
};
